import { ReactNode } from "react";

export function Background({ children }: { children: ReactNode }) {
  return (
    <div className="grid-rows-4items-center grid h-screen grid-cols-1 md:grid-cols-2 md:grid-rows-2">
      {children}
    </div>
  );
}
